export const browserNavigation = {
  location(): { assign(url: string): void } {
    return globalThis.location;
  },

  assign(url: string): void {
    this.location().assign(url);
  },
};
